import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  const faqs = [
    {
      q: "O que é uma landing page?",
      a: "Uma landing page é um site de página única criado para gerar contatos ou clientes. Ela apresenta seu serviço de forma clara e direciona o visitante para uma ação, como entrar em contato pelo WhatsApp ou preencher um formulário.",
    },
    {
      q: "As páginas são feitas apenas para rodar anúncios?",
      a: "Não necessariamente. Podemos criar páginas focadas em conversão para anúncios ou sites institucionais profissionais para apresentar sua empresa na internet.",
    },
    {
      q: "O site funciona no celular?",
      a: "Sim, todas as páginas são 100% responsivas e otimizadas para dispositivos móveis.",
    },
    {
      q: "Preciso entender de tecnologia?",
      a: "Não! Você só precisa enviar as informações básicas do seu negócio (textos, logo e fotos). Nós cuidamos de toda a parte técnica.",
    },
    {
      q: "Quanto tempo demora para ficar pronto?",
      a: "A Landing Page Express fica pronta em até 72 horas. Sites institucionais em até 5 dias, e a solução completa em até 7 dias.",
    },
    {
      q: "Posso rodar anúncios depois de ter a página?",
      a: "Com certeza! Nossas páginas são criadas especificamente para receber tráfego pago do Google Ads e Meta Ads. Porém, para rodar anúncios recomendamos realizar o rastreamento do Pixel (Meta Ads) e Tag do Google ambos feitos no Google Tag Manager (GTM).",
    },
    {
      q: "Vocês configuram o pixel e tags de conversão?",
      a: "Sim! Oferecemos o serviço de Rastreamento Profissional que inclui Pixel Meta Ads, Tag Google Ads, eventos de conversão e Google Tag Manager.",
    },
  ];

  return (
    <section id="faq" className="py-24 md:py-32" ref={ref}>
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          className="text-center mb-16"
        >
          <span className="text-sm font-mono text-secondary uppercase tracking-widest">FAQ</span>
          <h2 className="text-3xl md:text-5xl font-bold mt-4">
            Perguntas <span className="gradient-text-blue">frequentes.</span>
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ delay: 0.2 }}
          className="max-w-2xl mx-auto"
        >
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((faq, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="glass-card rounded-xl border-0 px-6">
                <AccordionTrigger className="text-left font-semibold hover:no-underline py-5">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground pb-5">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQSection;
